import './Footer.css';
import '../GroupList/GroupList.css';

import React from 'react';
import { unescapeHtml } from '../../utils/stringUtils';
import { Template } from '../../pages/runtime-typechecker';

const isSSR = typeof window === 'undefined';

type FooterSectionProps = {
  template: Template;
};

export default function FooterSection({ template }: FooterSectionProps) {
  const html = isSSR ? template.footerData : unescapeHtml(template.footerData);

  return (
    <footer
      className="footerWrap visibilityAuto"
      suppressHydrationWarning={true}
      dangerouslySetInnerHTML={{
        __html: html
      }}
    />
  );
}
